module.exports = __webpack_public_path__ + "img/filter-bg.efc87aa6.png";